export default __webpack_public_path__ + "static/media/hannah_smith.015debc4.jpeg";